import { useI18n } from "@/contexts/I18nContext";

const APPLE_ID = import.meta.env.VITE_APPLE_APP_ID as string | undefined;
const GOOGLE_PKG = (import.meta.env.VITE_GOOGLE_PACKAGE as string | undefined) || 'com.swissez.app';

export function AppStoreBadges() {
  const { t } = useI18n();
  if (!APPLE_ID) return null;
  return (
    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 py-8">
      <a
        href={`https://apps.apple.com/app/swissez/id${APPLE_ID}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("site.app.aria_apple")}
      >
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt={t("site.app.aria_apple")}
          width={144}
          height={48}
          loading="lazy"
          decoding="async"
          className="h-12 w-auto"
        />
      </a>
      <a
        href={`https://play.google.com/store/apps/details?id=${GOOGLE_PKG}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("site.app.aria_google")}
      >
        <img
          alt={t("site.app.aria_google")}
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
          width={215}
          height={64}
          loading="lazy"
          decoding="async"
          className="h-16 w-auto"
        />
      </a>
    </div>
  );
}
